<template>
  <section :id="`comp_id_${compProps.elementId}`" :key="keyName">
    <component
      :is="compName"
      :compProps="uiProps"
      :compId="(compProps.elementId+'')"
      @action="actionHandle"
      @closeRecivedDialog="closeRecivedDialog"
      @useRedpacket="useRedpacket"
      @openWebView="openWebView"
      @closeQActivityDialog="closeQActivityDialog"
      @receiveQActivityDialog="receiveQActivityDialog"
    ></component>
    <component :is="servCompName" :payLoad="payLoad" :compIndex="compIndex" :compProps="compProps" @init="initHandle" @finish="finishHandle"></component>
  </section>
</template>
<script>
import RedPacket from '@/components/RedPacket'
import serviceComps from './../serviceComps'
import mixin from '@/mixin/compMixin.js'
import sendLog from '@/utils/q_log'
import { openScheme } from '@/utils/q_business'
import { POINT_TYPE_ENUM } from './../serviceComps/config/redPackConfig'
export default {
  mixins: [mixin],
  data() {
    return {
      uiProps: {
        items: [],
        recivedRepackList: [],
        dialog: {
          showRedDialog: false,
          hasDialog: this.compProps.mate.privateProps.hasDialog,
          hasRedPackModel: this.compProps.mate.privateProps.hasRedPackModel,
          bgImg: this.compProps.mate.privateProps.receivedSuccessImgUrl
        }
      },
      payLoad: null
    }
  },
  components: {
    RedPacket,
    ...serviceComps
  },
  props: {
    compProps: {
      type: Object,
      default: function() {
        return {}
      }
    },
    compIndex: {
      type: String,
      default: function() {
        return ''
      }
    }
  },
  computed: {
    compName() {
      // 这里我偷懒了。本来应该秒杀红包和普通红包准备2个不同的ui组件。但是在交互逻辑上都一样。就只写了一个组件，这是不合规的。
      switch (this.compProps.mate.mode) {
      case '0':
      case '1':
        return 'RedPacket'
      default:
        return ''
      }
    },
    keyName() {
      return this.$root.promotionId + this.compProps.elementId + ''
    }
  },
  methods: {
    /**
     * 初始化接口，用于获得业务组件的初始化数据
     */
    initHandle(payload) {
      this.uiProps.items = payload
    },
    /**
     * UI交互组件对用户的交互派发接口，将UI组件用户交互的事件信息发送给业务组件
     */
    actionHandle(payload) {
      if (!this.$root.isPreview) {
        this.payLoad = {
          ...payload,
          timeStamp: new Date().getTime()
        }
      }
    },
    /**
     * 关闭领取红包的提示弹层
     */
    closeRecivedDialog(redpacket) {
      // q宫格埋点日志
      if (process.env.VUE_APP_LOCAL === 'Q') {
        const logParam = {
          actPos: `${this.compIndex}_${redpacket.redPackIndex}`,
          actPage: `cms_${this.$root.promotionId}`,
          actText: `cms_${this.$root.promotionId}_closeRedpackDialog`
        }
        sendLog(logParam)
      }
      this.uiProps.dialog.showRedDialog = false
    },
    /**
     * Q投流活动授权弹窗关闭
     */
    closeQActivityDialog() {
      window._fas && window._fas.setCustomTrack({
        eventname: 'C_HOME_CMS_COUPON_CLICK',
        ext: {
          rank_list_id: this.$root.promotionId,
          rank_list_name: this.$root.htmlTitle,
          button: '取消'
        }
      })
      this.uiProps.dialog.showQActivityDialog = false
      if (this.uiProps.dialog.cancel) {
        this.uiProps.dialog.cancel()
      }
    },
    /**
     * Q投流活动授弹窗点击领取
     */
    receiveQActivityDialog() {
      window._fas && window._fas.setCustomTrack({
        eventname: 'C_HOME_CMS_COUPON_CLICK',
        ext: {
          rank_list_id: this.$root.promotionId,
          rank_list_name: this.$root.htmlTitle,
          button: '领取'
        }
      })
      this.uiProps.dialog.showQActivityDialog = false
      if (this.uiProps.dialog.confirm) {
        this.uiProps.dialog.confirm()
      }
    },
    /**
     * Q投流活动授弹窗点击领取
     */
    openWebView({ url }) {
      if (url) {
        // 不加title不展示navbar
        openScheme(url, 'navibar-normal', ' ')
      }
    },
    /**
     * 当业务组件处理完用户的交互动作后，将结果通过这个接口返回给Ui组件
     * 不要嫌麻烦，这样做的目的是彻底剥离业务与视图，达到视图和业务的自由组合目的
     */
    finishHandle(payLoad) {
      this.payLoad = null
      const index = this.uiProps.items.findIndex((item) => item.id === payLoad.data.id)
      // console.log(payLoad)
      if (payLoad.type === 'showQActivityDialog') {
        this.uiProps.dialog = {
          showQActivityDialog: true,
          confirm: payLoad.data.confirm,
          cancel: payLoad.data.cancel
        }
        window._fas && window._fas.setCustomTrack({
          eventname: 'C_HOME_CMS_COUPON_EXPOSURE',
          ext: {
            rank_list_id: this.$root.promotionId,
            rank_list_name: this.$root.htmlTitle
          }
        })
      } else if (payLoad.type === 'doRedpacket') {
        this.uiProps.items[index].receive = true
      } else if (payLoad.type === 'redpacketDone') {
        this.uiProps.items[index].receive = true
      } else if (payLoad.type === 'overRedpacket') {
        this.uiProps.items[index].activityStatus = 4

      // hack/qunar: 强制更新时间戳，以便下次重复点击时，数据无变化也能触发vue的watch特性
      } else if (payLoad.type === 'updateUnLoginTimeStamp') {
        this.uiProps.items[index].timeStamp = Date.now()
      } else if (payLoad.type === 'doRedpacketAndShowListToast') {
        let dialog = {
          hasDialog: this.compProps.mate.privateProps.hasDialog,
          hasRedPackModel: this.compProps.mate.privateProps.hasRedPackModel,
          showRedDialog: true,
          bgImg: this.compProps.mate.privateProps.redPackModelImgUrl,
          redPackModelUseImg: this.compProps.mate.privateProps.redPackModelUseImg
        }
        this.uiProps.dialog = dialog
        setTimeout(() => {
          this.uiProps.recivedRepackList = payLoad.data.recivedRepackList
          this.uiProps.items[index].receive = true
        }, 500)
      } else if (payLoad.type === 'receiveRedpacketAndShowListToast') {
        let dialog = {
          hasDialog: this.compProps.mate.privateProps.hasDialog,
          hasRedPackModel: this.compProps.mate.privateProps.hasRedPackModel,
          showRedDialog: true,
          bgImg: this.compProps.mate.privateProps.receivedSuccessImgUrl
        }
        this.uiProps.dialog = dialog
        setTimeout(() => {
          this.uiProps.recivedRepackList = payLoad.data.recivedRepackList
          this.uiProps.items[index].receive = true
        }, 500)
      } else if (payLoad.type === 'recivePointsSuccess') {
        this.$set(this.uiProps.items[index], 'status', POINT_TYPE_ENUM.USE_NOW)
        this.$forceUpdate()
      }
    },
    /**
     * 使用红包
     * @param {Object} redpacket 点击的红包
     */
    useRedpacket(redpacket, flag) {
      this.payLoad = {
        ...redpacket,
        timeStamp: new Date().getTime(),
        toUse: flag
      }
    }
  }
}
</script>
